import { CountUp } from 'countup.js';
import g from '#core/global';
import events from '#core/events';
import load from '#core/load';
import layout from '#core/layout';
import util from '#core/util';


const value_$ = '.statistic-number__value';
const countup_to_attr = 'data-countup-to';

let has_statistic_number = false;
let $scroll_values = null;
const has_run = [];
let counter_id = 0;


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('statistic-number')) return false;

		load.all(() => {
			has_statistic_number = assign_elements();
			if (!has_statistic_number) return false;

			assign_scroll_events();
		});
	},

};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_statistic_number) return true;

	const $values = document.querySelectorAll(`${value_$}[${countup_to_attr}]`);
	if (!$values.length) return false;

	const scroll_managed = [];

	$values.forEach($el => {
		if (!$el.id) {
			$el.id = 'statistic-number-' + (++counter_id);
		}

		const $reveal = $el.closest(
			`[${g.reveal_attr}], [${g.revealing_attr}], [${g.revealed_attr}]`
		);

		if ($reveal) {
			bind_to_reveal($el, $reveal);
		} else {
			scroll_managed.push($el);
		}
	});

	$scroll_values = scroll_managed;
	check_countups();
	return true;
}


/**
 * Bind countup to a reveal ancestor's lifecycle
 * @param {Element} $el
 * @param {Element} $reveal
 */
function bind_to_reveal($el, $reveal) {
	if (
		$reveal.hasAttribute(g.revealed_attr)
		|| $reveal.hasAttribute(g.revealing_attr)
	) {
		run_countup($el);
	} else {
		$reveal.addEventListener(events.reveal.start, () => {
			run_countup($el);
		}, { once: true });
	}
}


/**
 * Assign scroll events
 */
function assign_scroll_events() {
	window.addEventListener(g.scroll_e, util.throttle(() => {
		check_countups();
	}, 250));
}


/**
 * Run CountUp animation on element
 * @param {Element} $element
 */
function run_countup($element) {
	const id = $element.id;
	const countup_to = parseFloat($element.getAttribute(countup_to_attr));
	if (!id || isNaN(countup_to)) return false;

	const has_decimals = countup_to % 1 !== 0;

	let countup = new CountUp(id, countup_to, {
		duration: 2.5,
		decimalPlaces: has_decimals ? 1 : 0,
		useGrouping: true,
	});

	if (!countup.error) {
		countup.start();
	}
}


/**
 * Check if scroll-managed values are visible and trigger countup
 */
function check_countups() {
	if (!$scroll_values) return false;

	$scroll_values.forEach($el => {
		if (has_run.includes($el.id)) return false;

		const is_visible = layout.isIntersecting({
			$element: $el,
			lookaround: 1,
		});
		if (!is_visible) return false;

		has_run.push($el.id);
		run_countup($el);
	});
}
